import { render, staticRenderFns } from "./data-overall.vue?vue&type=template&id=8904f4d0&scoped=true"
import script from "./data-overall.vue?vue&type=script&lang=js"
export * from "./data-overall.vue?vue&type=script&lang=js"
import style0 from "./data-overall.vue?vue&type=style&index=0&id=8904f4d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8904f4d0",
  null
  
)

export default component.exports